export default "__VITE_ASSET__BKzciWqV__"